import Vue from 'vue'
import settings from "./config";

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) {//指令名称为：real-img
  let defaultURL = settings.baseUrl + "/defimg.jpg";//错误默认显示图片

  let imgURL = binding.value;//获取图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute('src', imgURL);
    } else {
      let exist1 = await imageIsExist(imgURL.replace('.jpg', '.png'));
      if (exist1) {
        el.setAttribute('src', imgURL.replace('.jpg', '.png'));
      } else {
        el.setAttribute('src', defaultURL);
      }
    }
  } else {
    el.setAttribute('src', defaultURL);
  }
})

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function (url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      if (this.complete === true) {
        resolve(true);
        img = null;
      }
    }
    img.onerror = function () {
      resolve(false);
      img = null;
    }
    img.src = url;
  })
}

export default {
  install(Vue) {
    // 防重复点击(指令实现)
    Vue.directive('preventReClick', {
      inserted(el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 3000)
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/plugins.js